/* eslint-disable complexity */
import i18next from "i18next"
import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { NewsItemType } from "~/api/types/NewsList"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { LinksBundle } from "~/components/LinksBundle/LinksBundle"
import { Raw } from "~/components/raw"

import { CardNews } from "./components/CardNews/CardNews"
import styles from "./index.module.css"

const createNewsItems = (arr: NewsItemType[], newArr: NewsItemType[]): NewsItemType[] => {
  arr.forEach((item) => {
    if (item) {
      newArr.push(item)
    }
  })

  return newArr
}

export const NewsWrapper: React.FC = () => {
  const { t } = useTranslation()
  const currentLang = i18next.language
  const newsMainpage = useApiContext("/mainpage/news")
  const isNewsMainpageEmpty = !newsMainpage || newsMainpage.length === 0
  const { items: pressReleases } = useApiContext("/pressreleases/list")
  const { items: newsItems } = useApiContext("/news/list")
  const news = Array.isArray(newsItems) ? newsItems : []
  const { items: irBlog } = useApiContext("/ir/list")
  const { items: media } = useApiContext("/media/list")

  const newsMainpageMax = newsMainpage.slice(0, 6)
  const mobileNewsList: NewsItemType[] = []
  const lastPress: NewsItemType[] = []

  const lastPressItemsRu = [
    pressReleases[0],
    news[0],
    media[0],
    pressReleases[1],
    news[1],
    media[1],
  ]
  const lastPressItemsEn = [
    pressReleases[0],
    news[0],
    irBlog[0],
    media[0],
    pressReleases[1],
    news[1],
  ]
  const mobileNewsItemsRu = [pressReleases[0], pressReleases[1], news[0], media[0]]
  const mobileNewsItemsEn = [pressReleases[0], news[0], media[0], irBlog[0]]

  if (isNewsMainpageEmpty && currentLang === "ru") {
    createNewsItems(lastPressItemsRu, lastPress)
  }

  if (isNewsMainpageEmpty && currentLang === "en") {
    createNewsItems(lastPressItemsEn, lastPress)
  }

  if (currentLang === "ru") {
    createNewsItems(mobileNewsItemsRu, mobileNewsList)
  }

  if (currentLang === "en") {
    createNewsItems(mobileNewsItemsEn, mobileNewsList)
  }

  return (
    <div className={styles.Wrapper}>
      <div className="container">
        <div className={styles.Heading}>
          <Heading as="h2" className={styles.Title} like="h1">
            <Raw html={t("home.NewsWrapper.Title")} />
          </Heading>

          <LinksBundle>
            <Link href="/press/pressreleases" view="arrow">
              <Raw html={t("home.NewsWrapper.LinksBundle.Link.01")} />
            </Link>
            {/* NOTE: ссылка на «Новости активов» временно скрыта */}
            {/* <Link href="/press/news" view="arrow">
              <Raw html={t("home.NewsWrapper.LinksBundle.Link.02")} />
            </Link> */}
            {currentLang === "ru" && (
              <Link href="/press/media" view="arrow">
                <Raw html={t("home.NewsWrapper.LinksBundle.Link.03")} />
              </Link>
            )}
            {currentLang === "ru" && (
              <Link href="/press/massmedia" view="arrow">
                <Raw html={t("home.NewsWrapper.LinksBundle.Link.04")} />
              </Link>
            )}
            {currentLang === "en" && (
              <Link href="/investors-and-shareholders/ir-blog" view="arrow">
                <Raw html={t("page.ir-blog")} />
              </Link>
            )}
          </LinksBundle>
        </div>

        <div className={styles.CardsDesktop}>
          {!isNewsMainpageEmpty &&
            newsMainpageMax.map((item, i) => (
              <CardNews
                slug={item.type}
                {...item}
                key={i}
                className={styles.Card}
                isBig={i === 0 || i === 5}
              />
            ))}

          {isNewsMainpageEmpty &&
            lastPress.map((item, i) => (
              <CardNews
                slug={item.type}
                {...item}
                key={i}
                className={styles.Card}
                isBig={i === 0 || i === 5}
              />
            ))}
        </div>

        <div className={styles.CardsMobile}>
          {mobileNewsList.map((item, i) => (
            <CardNews slug={item.type} {...item} key={i} className={styles.Card} />
          ))}
        </div>
      </div>
    </div>
  )
}
